import { createSlice } from '@reduxjs/toolkit';

const forecastSlice = createSlice({
  name: 'forecast',
  initialState: {
    forecastData: {} // interactionId -> structureId -> { productName, months: [...] }
  },
  reducers: {
    storeForecastData: (state, action) => {
      const { interactionId, structureId, response } = action.payload;
      
      // Validate IDs
      if (!interactionId || !structureId || !response) return;

      // Reset if corrupted type
      if (typeof state.forecastData !== 'object' || Array.isArray(state.forecastData)) {
        state.forecastData = {};
      }

      // Ensure nested object for interactionId
      if (
        typeof state.forecastData[interactionId] !== 'object' ||
        Array.isArray(state.forecastData[interactionId])
      ) {
        state.forecastData[interactionId] = {};
      }

      state.forecastData[interactionId][structureId] = response;
    },

    resetForecastData: (state) => {
      state.forecastData = {};
    }
  }
});

export const { storeForecastData, resetForecastData } = forecastSlice.actions;
export default forecastSlice.reducer;
